import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useGetToken } from '../../config';

type TCallVariables = {
  token: string;
  propertyId: string;
  ticketTypeId: string;
};

export const call = ({ token, propertyId, ticketTypeId }: TCallVariables) =>
  axios.get(
    `property/${propertyId}/ticket-type/${ticketTypeId}/available-dates`,
    {
      headers: {
        'X-API-Key': token,
      },
      params: {
        limit: 100,
      },
    }
  );

const K_GET_PROPERTY_CONTAINERS = 'K_GET_PROPERTY_CONTAINERS';

export const useGetPropertyTicketTypeAvailableDates = (
  vars: Omit<TCallVariables, 'token'>
) => {
  const token = useGetToken();
  return useQuery<$TSFixMe>({
    queryKey: [K_GET_PROPERTY_CONTAINERS, vars],
    queryFn: () => call({ token, ...vars }),
  });
};
